"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var positioning_1 = require("./positioning");

var validate_css_1 = __importDefault(require("./validate.css"));

var defaultColor = '#222';

var default_1 =
/** @class */
function (_super) {
  __extends(default_1, _super);

  function default_1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  default_1.prototype.render = function () {
    var _a = this.props,
        passRef = _a.passRef,
        visible = _a.visible,
        placement = _a.placement,
        popperArrowProps = _a.popperArrowProps,
        children = _a.children,
        _b = _a.borderWidth,
        borderWidth = _b === void 0 ? 0 : _b,
        bubbleBorderWidth = _a.bubbleBorderWidth,
        arrowBorderWidth = _a.arrowBorderWidth,
        _c = _a.borderStyle,
        borderStyle = _c === void 0 ? 'solid' : _c,
        bubbleBorderStyle = _a.bubbleBorderStyle,
        arrowBorderColor = _a.arrowBorderColor,
        _d = _a.borderColor,
        borderColor = _d === void 0 ? '#b3b3b3' : _d,
        bubbleBorderColor = _a.bubbleBorderColor,
        arrowBorderStyle = _a.arrowBorderStyle,
        _e = _a.bubbleProps,
        bubbleProps = _e === void 0 ? {} : _e,
        _f = _a.arrowProps,
        arrowProps = _f === void 0 ? {} : _f,
        style = _a.style,
        _g = _a.arrowSize,
        arrowSize = _g === void 0 ? 6 : _g,
        _h = _a.arrowStyle,
        arrowStyle = _h === void 0 ? {} : _h,
        _j = _a.bubbleStyle,
        bubbleStyle = _j === void 0 ? {} : _j,
        _k = _a.commonStyle,
        commonStyle = _k === void 0 ? {} : _k;

    var customStyle = bubbleProps.style,
        customProps = __rest(bubbleProps, ["style"]);

    var customArrowStyle = arrowProps.style,
        customDivProps = __rest(arrowProps, ["style"]);

    if (customArrowStyle) {
      throw new TypeError("[@jonny/ui]: Pass 'arrowStyle' instead of 'arrowProps.style'");
    }

    if (customStyle) {
      throw new TypeError("[@jonny/ui]: Pass 'bubbleStyle' instead of 'bubbleProps.style'");
    }

    validate_css_1.default(commonStyle);
    var actualBubbleBorderWidth = typeof bubbleBorderWidth === 'undefined' ? borderWidth : bubbleBorderWidth;
    var actualArrowBorderWidth = typeof arrowBorderWidth === 'undefined' ? borderWidth : arrowBorderWidth;
    return react_1.default.createElement("div", __assign({
      ref: passRef,
      style: __assign({
        visibility: visible ? 'visible' : 'hidden',
        display: 'block',
        color: 'white',
        background: defaultColor,
        borderRadius: 3,
        paddingLeft: 13,
        paddingRight: 13,
        paddingTop: 9,
        paddingBottom: 9,
        fontSize: 12,
        zIndex: 1,
        textAlign: 'left',
        fontWeight: 300,
        borderWidth: actualBubbleBorderWidth,
        borderStyle: bubbleBorderStyle || borderStyle,
        borderColor: bubbleBorderColor || borderColor
      }, style, positioning_1.getContainerStyle(placement, actualBubbleBorderWidth, arrowSize), commonStyle, bubbleStyle)
    }, customProps, {
      "data-placement": placement
    }), react_1.default.createElement("div", __assign({
      ref: popperArrowProps.ref,
      style: __assign({}, popperArrowProps.style, positioning_1.getArrowStyle(placement, actualBubbleBorderWidth, actualArrowBorderWidth, arrowBorderStyle || borderStyle, arrowBorderColor || borderColor, arrowSize), {
        backgroundColor: defaultColor
      }, commonStyle, arrowStyle)
    }, customDivProps)), children);
  };

  return default_1;
}(react_1.Component);

exports.default = default_1;